<template>
  <div class="paper-student-preview-has-match">
    <TemplateDataGrid gridId="PePaperStudentQueryHasMatch" v-bind="gridParams"></TemplateDataGrid>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../../../templates/TemplateDataGrid'
export default {
  name: 'PaperStudentPreviewHasMatch',
  components: {
    TemplateDataGrid
  },
  props: {
    gridParams: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.paper-student-preview-has-match {
  height: 100%;
}
</style>
